import React from "react";
import { Link } from "react-router-dom";
import { ajax } from "../components/globals";
import { Languages } from "../components/languages";

export default class VerifyRecoveryMail extends React.Component {
    constructor(props) {
        super(props);

        this.le = Languages.PasswordRecovery[Languages.selectedLanguage];
        const params = new URLSearchParams(props.location.search);

        this.state = {
            token: params.get("token") || "",
            loading: true,
            message: "",
            error: ""
        };

        window.history.replaceState(
            {},
            document.title,
            "/verify-recovery-mail"
        );
    }

    componentDidMount() {
        if (!this.state.token) {
            this.setState({
                loading: false,
                error: this.le.common.invalidLink
            });
            return;
        }

        ajax(
            this,
            {
                method: "post",
                url: "/api/user/recovery-mail/confirm",
                data: {
                    token: this.state.token
                }
            },
            () => {
                this.setState({
                    token: "",
                    loading: false,
                    message: this.le.verification.success,
                    error: ""
                });
            },
            () => {
                this.setState({
                    token: "",
                    loading: false,
                    message: "",
                    error: this.le.common.invalidLink
                });
            }
        );
    }

    render() {
        const statusMessage =
            this.state.loading
                ? this.le.verification.loading
                : this.state.message || this.state.error;

        return (
            <div className="full-panel page-password-recovery">
                <div className="page-login">
                    <div
                        className={
                            "widget " +
                            (this.state.loading ? "disabled" : "")
                        }
                    >
                        <div className="widget-header">
                            <div className="login-header-logo" />
                        </div>

                        <div className="widget-content">
                            <div className="widget-content-title">
                                {this.le.verification.title}
                            </div>

                            <div
                                className={
                                    this.state.error
                                        ? "login-error"
                                        : "password-recovery-message"
                                }
                                role="status"
                                aria-live="polite"
                            >
                                {statusMessage}
                            </div>

                            <Link
                                className="forgot-password-link"
                                to="/"
                            >
                                {this.le.common.backToLogin}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}